
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class Pelletsheizung extends Vue {
  head() {
    return {
      ...generateMetaTags(this.$route.path, "pelletsheizung"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Welche Faktoren bestimmen die Pelletheizung-Auswahl?",
        title: "Springen Sie zum Bereich für Infos zu: Faktoren",
        href: {
          hash: "#first-anker",
        },
      },
      {
        name: "Pelletheizung Arten: Die drei Haupttypen im Vergleich",
        title: "Springen Sie zum Bereich für Infos zu: Pelletheizung Arten",
        href: {
          hash: "#second-anker",
        },
      },
      {
        name: "Die richtige Entscheidung treffen",
        title: "Springen Sie zum Bereich für Infos zu: Entscheidung",
        href: {
          hash: "#third-anker",
        },
      },
    ];
  }
}
